<template>
  <MainHeader>
    <!-- Sildeovers -->
    <CustomerSearchSlideover
      title="Customer Search"
      :visible="slideoverVisibleSearch"
      v-on:toggle-slideover="toggleSlideover('customerSearch')"
    />
    <CustomerEditSlideover
      title="Edit Customer"
      :visible="slideoverVisibleEdit"
      v-on:toggle-slideover="toggleSlideover('customerEdit')"
      v-bind:customer="customer"
    />
    <CustomerUnsubscribeOptionsSlideover
      title="Do Not Contact Options"
      :visible="slideoverVisibleUnsubscribeOptions"
      v-on:toggle-slideover="toggleSlideover('unsubscribeOptions')"
      v-bind:customer="customer"
    />

    <div class="lg:flex lg:items-center lg:justify-between">
      <!-- Left side -->
      <div class="flex-1 min-w-0">
        <div class="flex items-center pr-4 sm:truncate">
          <h1
            class="text-2xl font-bold leading-7 text-cool-gray-900 sm:leading-9"
          >
            {{
              loaded
                ? `${customer.FirstName} ${customer.LastName}`
                : "Customers"
            }}
            <button
              v-if="loaded"
              type="button"
              @click="toggleSlideover('customerEdit')"
            >
              <icon
                set="solid"
                name="pencil-alt"
                class="h-5 w-5  text-green-500 mb-0"
              />
            </button>
          </h1>
        </div>

        <ul
          v-if="loaded"
          class="mt-1 flex flex-col space-x-4 sm:mt-0 sm:flex-row sm:flex-wrap"
        >
          <li>
            <icon
              set="solid"
              name="identification"
              class="w-5 h-5 text-cool-gray-400"
            />
            <span>#{{ customer.CustomerID }}</span>
          </li>

          <li>
            <icon
              set="solid"
              name="location-marker"
              class="w-5 h-5 text-cool-gray-400"
            />
            <span
              >{{ customer.Address }} {{ customer.City }}, {{ customer.State }}
              {{ customer.Zip }}</span
            >
          </li>

          <li>
            <icon set="solid" name="phone" class="w-5 h-5 text-cool-gray-400" />
            <span>{{ customer.Phone }}</span>
          </li>

          <li>
            <icon set="solid" name="mail" class="w-5 h-5 text-cool-gray-400" />
            <span>{{ customer.Email }}</span>
          </li>
        </ul>
      </div>

      <!-- Right side  -->
      <div class="mt-5 flex lg:mt-0 lg:ml-4 space-x-2">

        <div
          v-if="loaded"
          class="flex flex-row justify-end"
        >
          <div class="relative inline-block text-left z-10">
            <div>
              <span class="rounded-md shadow-sm">
                <Button
                  v-on:click-handler="toggleOrderActions"
                  class="btn relative z-10"
                >
                  Actions
                  <icon
                    set="solid"
                    name="chevron-down"
                    class="-mr-1 ml-2 h-5 w-5"
                  />
                </Button>
                <button
                  v-if="showCustomerActions"
                  @click="showCustomerActions = false"
                  tabindex="-1"
                  class="fixed inset-0 w-full h-full bg-black opacity-50 cursor-default"
                ></button>
              </span>
            </div>
            <transition
              enter-active-class="ease-out duration-100"
              enter-class="opacity-0 scale-95"
              enter-to-class="opacity-100 scale-100"
              leave-active-class="ease-in duration-75"
              leave-class="opacity-100 scale-100"
              leave-to-class="opacity-0 scale-95"
            >
              <div
                v-if="showCustomerActions"
                class="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg"
              >
                <div class="rounded-md bg-white shadow-xs">
                  <div
                    class="py-1"
                    role="menu"
                    aria-orientation="vertical"
                    aria-labelledby="options-menu"
                  >
                    <button
                      @click="toggleSlideover('unsubscribeOptions') || toggleOrderActions()"
                      class="block w-full px-4 py-2 text-sm leading-5 text-gray-700 hover:text-gray-900 text-left hover:bg-gray-100"
                      role="menuitem"
                    >
                      Do Not Contact Options
                    </button>
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </div>

        <Button v-on:click-handler="toggleSlideover('customerSearch')">
          Advanced Search
        </Button>
      </div>
    </div>
  </MainHeader>
</template>
<script>
/**
 * TODO
 */
import MainHeader from "@/components/elements/MainHeader.vue";
import Button from "@/components/elements/Button.vue";
import CustomerEditSlideover from "../components/slideovers/CustomerEdit.vue";
import CustomerSearchSlideover from "../components/slideovers/CustomerSearch.vue";
import CustomerUnsubscribeOptionsSlideover from "../components/slideovers/CustomerUnsubscribeOptions.vue";

export default {
  name: "CustomerInfo",
  data() {
    return {
      showCustomerActions: false,
      slideoverVisibleEdit: false,
      slideoverVisibleSearch: false,
      slideoverVisibleUnsubscribeOptions: false,
    };
  },
  props: {
    customer: {
      type: Object
    },
    loaded: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  created() {},
  components: {
    MainHeader,
    Button,
    CustomerEditSlideover,
    CustomerSearchSlideover,
    CustomerUnsubscribeOptionsSlideover,
  },
  computed: {},
  methods: {
    toggleOrderActions() {
      this.showCustomerActions = ! this.showCustomerActions;
    },
    toggleSlideover(slideover) {
      if (slideover == "customerSearch")
        this.slideoverVisibleSearch = !this.slideoverVisibleSearch;
      if (slideover == "customerEdit")
        this.slideoverVisibleEdit = !this.slideoverVisibleEdit;
      if (slideover == "unsubscribeOptions")
        this.slideoverVisibleUnsubscribeOptions = !this.slideoverVisibleUnsubscribeOptions;
    }
  },
  filters: {}
};
</script>
<style scoped>
.link {
  @apply ml-0 text-green-600 transition duration-150 ease-in-out;
}

.link:hover {
  @apply text-green-500 underline;
}

li {
  @apply inline-flex;
}
</style>
